import { render, staticRenderFns } from "./workDayFx.vue?vue&type=template&id=0b2df552&scoped=true"
import script from "./workDayFx.vue?vue&type=script&lang=js"
export * from "./workDayFx.vue?vue&type=script&lang=js"
import style0 from "./workDayFx.vue?vue&type=style&index=0&id=0b2df552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2df552",
  null
  
)

export default component.exports